<template>
  <h5 class="card-title">
    <span :class="{ 'card-title-underline': !noUnderline }">
      <slot />
    </span>
  </h5>
</template>

<script>
export default {
  name: 'BaseCardTitle',

  props: {
    noUnderline: {
      default: false,
      type: Boolean
    }
  }
}
</script>
